import LotteryMaintenance from './LotteryMaintenance.vue'

export default LotteryMaintenance
